import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { delay: { type: Number, default: 100 } }

  submit (event) {
    event.stopPropagation()
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      event.target.form?.requestSubmit()
    }, this.delayValue)
  }

  disconnect () {
    clearTimeout(this.timeout)
  }
}
